import { Injectable, EventEmitter } from '@angular/core';
import { timer as observableTimer } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import * as _lodash from 'lodash';
import { UserManager, UserManagerSettings, User, WebStorageStateStore } from 'oidc-client';
import { EnvironmentConfiguration,environments } from '../../environment/services/environment.configuration';
import { SharedDataService } from './shared-data.service';
import { MatDialog } from '@angular/material/dialog';
const environment = new EnvironmentConfiguration(environments); 
@Injectable({
  providedIn: 'root'
})
export class AuthServiceForgerock {

  readonly mstLogoutExpiresAt = 'mst-logout-expires_at';

  private isSilentRenewError = false;
  //private manager = new UserManager(getClientSettings());
  private manager: UserManager;// = new UserManager(getClientSettings());
  userLoadededEvent: EventEmitter<User> = new EventEmitter<User>();
  private user: User = null;
  currentUser: User;
  // flag to checked logged in
  loggedIn: boolean = false;
  // flag to checked logged in
  isSessionExtenstion: boolean = false;
  // to store authheaders
  authHeaders: Headers;
  // to store route url
  originalRouteURL: string;
  nextTokenUpdateTime : any;
  // Subscriber for Token Refresh Timer
  private tokenRefresher$: any = null;
  // Subscriber for Token Validator Timer
  private tokenValidator$: any = null;
  public showPopupBlockerPrompt: () => void;
  baseURL: string = this.environment.AUTH_BASE_URL;
  // Constant for Refresh Token Invoked
  static REFRESH_TOKEN_INVOKED: string = 'refreshTokenInvoked';
  // Constant for Time to refresh token => min * seconds * milliseconds
  static REFRESH_TOKEN_TIME_PERIOD: number = 55 * 60 * 1000; // => 55 min
  // Constant for Time to verify if token is refreshed => min * seconds * milliseconds
  static REFRESH_TOKEN_VERIFICATION_TIME_PERIOD: number = 60 * 60 * 1000; // => 60 min
  // Constant for Time to logout => hours * min * seconds * milliseconds
  static LOGOUT_PERIOD: number = 8* 60 * 60 * 1000;  // => 8 hrs
  // Constant for Disclaimer Indicator

  constructor(private environment : EnvironmentConfiguration, private dialog: MatDialog, private sharedDataService: SharedDataService) {
   this.configureManager(false);

  }
  isSessionExpiryAlertAlreadyDisplayed() {
    return this.dialog.getDialogById('conSessionExpiryDialog');
}

  configureManager(isMfa) {
    console.log("****************************  configureManager *******************************");
      this.manager = new UserManager(getClientSettings());
    this.manager.getUser().then(user => {
      console.log("****************************  Current User *******************************", user);
      this.user = user;
    });
  }
  isLoggedIn(): boolean {
    return this.currentUser != null && !this.currentUser.expired;
  }

  getClaims(): any {
    return this.currentUser.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.currentUser.token_type} ${this.currentUser.access_token}`;
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }
  isUserAuthorized() {
    if (this.currentUser &&
      (this.currentUser.profile.roles
        .indexOf('DD_RTI_MST_Console') > -1)) {
      return true;
    } else {
      return false;
    }
  }
  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      console.log("****************************  signinRedirectCallback  user*******************************", user);
      this.user = user;
    });
  }
  getUser() {
    let that = this;
    return this.manager.getUser().then((user) => {
      console.log("****************************  getUser  user*******************************", user);
      if(!_lodash.isNil(user)){
        const hasConsoleRole = user.profile.roles.includes('DD_RTI_MST_Console');
        if(!hasConsoleRole){
          const hasSalesConsultantRole = user.profile.roles.includes('DD_NewVehicleVMSExcludeCost');
          this.sharedDataService.isUserSalesConsultant = hasSalesConsultantRole ? true : false;
        }
      }
      return user;
    }).catch(function (err) {
      console.log(err);
    });
  }

  removeUser() {
    this.manager.removeUser().then(() => {
      console.log('user removed');
    }).catch(function (err) {
      console.log(err);
    });
  }

  startSigninMainWindow(url: string, isSetDealer = false) {
    if (isSetDealer) {
      this.manager = new UserManager(getClientSettings(isSetDealer));
    }
    console.log("****************************  startSigninMainWindow *******************************");
    this.manager.signinRedirect({ data: 'some data' }).then(function () {
      console.log("****************************  startSigninMainWindow  signinRedirect *******************************");
      console.log('signinRedirect done');
    }).catch(function (err) {
      console.log(err);
    });
  }

  endSigninMainWindow(url?: string) {
    return this.manager.signinRedirectCallback(url).then((user) => {
      console.log("****************************  endSigninMainWindow  signinRedirectCallback *******************************", user+ url);
      return user;
    }).catch(err => {
      console.log(err);
    });
  }
  startSignoutMainWindow() {
    let user: User;

    this.manager.getUser().then((usr) => {

      if (usr) {

        user = usr;

        this.manager .signoutRedirect({
            id_token_hint: user.id_token,
            extraQueryParams: { client_id: environment.MST_CONSOLE },
          }).then(() => {
            window.sessionStorage.clear();
            window.localStorage.removeItem('refreshTokenInvoked');
          }).catch((error) => {
            window.location.href = environment.POST_LOGOUT_REDIRECT_URL;
          });
      } else {
        window.sessionStorage.clear();
      }
    });
  }

  endSignoutMainWindow() {
    this.manager
      .signoutRedirectCallback();
  }

  /**
    * To schedule the token refresh timer for every 55 minutes(3300000 milliseconds)
    * and invocation unsubscribe refresh token at 8th hour(28800000 milliseconds) and invoke logout
    */
  scheduleRefreshToken() {
    this.nextTokenUpdateTime = new Date(new Date().getTime()
      + AuthServiceForgerock.REFRESH_TOKEN_TIME_PERIOD).toLocaleTimeString();
    console.log('************************ NEXT SILENT TESS TOKEN UPDATE on ************************ ' + this.nextTokenUpdateTime);
    // Schedule token refresh
    this.tokenRefresher$ = observableTimer(AuthServiceForgerock.REFRESH_TOKEN_TIME_PERIOD,
      AuthServiceForgerock.REFRESH_TOKEN_TIME_PERIOD).subscribe(x => {
        console.log('************************ scheduleRefreshToken observableTimer  ************************ ' + this.nextTokenUpdateTime);
        this.startRefreshToken();
        //this.openIdleUserDialog(true);
       
      });

  }

  logout() {

    console.log('************************ logout ************************ ');

    this.startSignoutMainWindow();
    this.manager.removeUser();
  }
 
  /***
  * Method to get the query string value
  */
  getQueryStringValue(url: string, key: string) {
    console.log('inside retrieve param');
    return decodeURIComponent(url.replace(new RegExp('^(?:.*[&\\?]' +
      encodeURIComponent(key).
        replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }
  private handleSilentRenewError() {

    console.log('************************ handleSilentRenewError ************************ ');

    if (!this.isSilentRenewError) {
      this.isSilentRenewError = true;
      this.startRefreshToken();
      console.log('************************ handleSilentRenewError startRefreshToken ************************ ');
    }
  }
  isUserTokenValid(user) {
    let jwtHelper = new JwtHelperService();
    return !(jwtHelper.isTokenExpired(user.access_token) ? jwtHelper.isTokenExpired(user.access_token) : false);
  }
  public startRefreshToken() {

    console.log('************************ startRefreshToken ************************ ');

    window.localStorage.setItem('refreshTokenInvoked', "true");
    this.startSilentRefresh().then( (user) => {
        this.isSilentRenewError = false;

        if (user && this.isUserTokenValid(user)) {
          window.sessionStorage.removeItem('id_token');
          window.sessionStorage.setItem('id_token',user.id_token);
          window.sessionStorage.removeItem('access_token');
          window.sessionStorage.setItem('access_token',user.access_token);
          window.localStorage.setItem('refreshTokenInvoked', "false");
          this.endSilentRefresh();
        }
      }
    ).catch((error) => {
      this.handleSilentRenewError();
      window.localStorage.setItem('refreshTokenInvoked', "true");
    });

  }
  private startSilentRefresh() {
    return this.manager.signinSilent();
  }
  private endSilentRefresh(): Promise<User> {
    return this.manager.signinSilentCallback().then((user) => {

      return user;
    });
  }


}
export function getClientSettings(isSetDealer = false): UserManagerSettings {
  let settings = {
    authority: environment.AUTH_AUTHORITY,
    client_id: environment.MST_CONSOLE,
    redirect_uri: environment.SILENT_REDIRECT_URL,
    post_logout_redirect_uri: environment.SILENT_REDIRECT_URL,
    response_type: 'code',
    scope: 'openid MST',
    silent_redirect_uri: environment.SILENT_REDIRECT_URL,
    silentRequestTimeout: 10000,
    filterProtocolClaims: true,
    loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    // For Silent Renew
    accessTokenExpiringNotificationTime: 60,
    includeIdTokenInSilentRenew: true,
    automaticSilentRenew: true,

    // For Signin Popup
    popup_redirect_uri: environment.SILENT_REDIRECT_URL,
    // Given maximum values for left and top
    popupWindowFeatures:
      'location=no,toolbar=no,menubar=no,titlebar=no,resizable=no,status=no,scrollbars=no,width=1155,height=686,left=0,top=0',
    popupWindowTarget: '_blank'
  };
  return settings;
}

